import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { ContextLibraryUploadedFileTypePage } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = ContextLibraryUploadedFileTypePage;
export type ContextLibraryData = TData;

export const useContextLibraryDataAll = (
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query contextLibrary($skipPagination: Boolean) {
      contextLibraryUploadedFiles(skipPagination: $skipPagination) {
        nodes {
          id
          filename
          filesize
          processed
          errorMessage
          tags {
            id
            name
          }
        }
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['useContextLibraryDataAll'],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables: { skipPagination: true }
        }
      })
  });
};
